import React from 'react';
import { CheckIcon } from 'lucide-react';
export function Pricing() {
  return <section id="precios" className="w-full bg-[#0a0a0a] py-20 px-4 sm:px-6 lg:px-8" data-id="element-212">
      <div className="max-w-7xl mx-auto" data-id="element-213">
        {/* Header */}
        <div className="text-center mb-14" data-id="element-214">
          <h2 className="font-heading font-bold text-white uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight" data-id="element-215">
            Precios simples (elige tu ritmo)
          </h2>
          <div className="section-divider" data-id="element-216" />
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch" data-id="element-217">
          {/* Card 1 — Clase Privada */}
          <div className="bg-[#1a1a1a] border border-[#2a2a2a] p-8 flex flex-col" data-id="element-218">
            <div className="mb-6" data-id="element-219">
              <h3 className="font-heading font-bold text-white uppercase text-xl tracking-widest mb-1" data-id="element-220">
                Clase Privada
              </h3>
              <p className="font-body text-gray-500 text-sm" data-id="element-221">
                Entrenamiento personal con atención directa del entrenador.
              </p>
            </div>
            <div className="mb-6" data-id="element-222">
              <span className="font-heading font-bold text-[#C9A84C] text-5xl" data-id="element-223">
                25€
              </span>
              <span className="font-body text-gray-500 text-sm ml-2" data-id="element-224">
                / clase
              </span>
            </div>
            <ul className="space-y-3 mb-8 flex-1" data-id="element-225">
              <li className="flex items-center gap-3" data-id="element-226">
                <CheckIcon size={14} className="text-[#C9A84C] flex-shrink-0" data-id="element-227" />
                <span className="font-body text-gray-400 text-sm" data-id="element-228">
                  Técnica personalizada
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-229">
                <CheckIcon size={14} className="text-[#C9A84C] flex-shrink-0" data-id="element-230" />
                <span className="font-body text-gray-400 text-sm" data-id="element-231">
                  Corrección de errores
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-232">
                <CheckIcon size={14} className="text-[#C9A84C] flex-shrink-0" data-id="element-233" />
                <span className="font-body text-gray-400 text-sm" data-id="element-234">
                  Progreso más rápido
                </span>
              </li>
            </ul>
            <a href="https://wa.me/34646585179?text=Hola%20Antonio,%20quiero%20reservar%20una%20clase%20privada.%20%C2%BFTen%C3%A9is%20disponibilidad%20esta%20semana?%20Gracias,%20espero%20tu%20respuesta." target="_blank" rel="noopener noreferrer" className="border border-[#C9A84C] text-[#C9A84C] hover:bg-[#C9A84C] hover:text-black font-heading font-bold px-6 py-3 text-sm tracking-widest uppercase transition-all duration-200 text-center" data-id="element-235">
              Reservar Clase Privada
            </a>
          </div>

          {/* Card 2 — Bono Clases Privadas (POPULAR) */}
          <div className="bg-[#1a1a1a] border border-[#2a2a2a] p-8 flex flex-col relative" data-id="element-236">
            {/* Badge */}
            <div className="absolute -top-3 left-1/2 -translate-x-1/2" data-id="element-237">
              <span className="bg-[#C9A84C] text-black font-heading font-bold text-xs px-4 py-1 uppercase tracking-widest" data-id="element-238">
                Popular
              </span>
            </div>
            <div className="mb-6" data-id="element-239">
              <h3 className="font-heading font-bold text-white uppercase text-xl tracking-widest mb-1" data-id="element-240">
                Bono Clases Privadas
              </h3>
              <p className="font-body text-gray-500 text-sm" data-id="element-241">
                Bono mínimo de 8 clases con mejor precio por sesión.
              </p>
            </div>
            <div className="mb-6" data-id="element-242">
              <span className="font-heading font-bold text-[#C9A84C] text-5xl" data-id="element-243">
                20€
              </span>
              <span className="font-body text-gray-500 text-sm ml-2" data-id="element-244">
                / clase
              </span>
            </div>
            <ul className="space-y-3 mb-8 flex-1" data-id="element-245">
              <li className="flex items-center gap-3" data-id="element-246">
                <CheckIcon size={14} className="text-[#C9A84C] flex-shrink-0" data-id="element-247" />
                <span className="font-body text-gray-400 text-sm" data-id="element-248">
                  Bono de 8 clases
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-249">
                <CheckIcon size={14} className="text-[#C9A84C] flex-shrink-0" data-id="element-250" />
                <span className="font-body text-gray-400 text-sm" data-id="element-251">
                  Plan de progreso
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-252">
                <CheckIcon size={14} className="text-[#C9A84C] flex-shrink-0" data-id="element-253" />
                <span className="font-body text-gray-400 text-sm" data-id="element-254">
                  Seguimiento técnico
                </span>
              </li>
            </ul>
            <a href="https://wa.me/34646585179?text=Hola%20Antonio,%20quiero%20informaci%C3%B3n%20sobre%20el%20bono%20de%20clases.%20Gracias,%20espero%20tu%20respuesta." target="_blank" rel="noopener noreferrer" className="bg-[#C9A84C]/20 border border-[#C9A84C] text-[#C9A84C] hover:bg-[#C9A84C] hover:text-black font-heading font-bold px-6 py-3 text-sm tracking-widest uppercase transition-all duration-200 text-center" data-id="element-255">
              Comprar Bono
            </a>
          </div>

          {/* Card 3 — Clases Grupales (RECOMENDADO) */}
          <div className="bg-[#1a1a1a] border-2 border-[#C9A84C] p-8 flex flex-col relative shadow-xl shadow-[#C9A84C]/10" data-id="element-256">
            {/* Badge */}
            <div className="absolute -top-3 left-1/2 -translate-x-1/2" data-id="element-257">
              <span className="bg-[#C9A84C] text-black font-heading font-bold text-xs px-4 py-1 uppercase tracking-widest" data-id="element-258">
                ⭐ Recomendado
              </span>
            </div>
            <div className="mb-6" data-id="element-259">
              <h3 className="font-heading font-bold text-white uppercase text-xl tracking-widest mb-1" data-id="element-260">
                Clases Grupales
              </h3>
              <p className="font-body text-gray-500 text-sm" data-id="element-261">
                Planes mensuales según cuántas clases quieras hacer por semana.
              </p>
            </div>

            {/* Pricing table */}
            <div className="mb-6 space-y-2" data-id="element-262">
              <div className="flex items-center justify-between py-2 border-b border-[#2a2a2a]" data-id="element-263">
                <span className="font-body text-gray-300 text-sm" data-id="element-264">
                  2 clases / semana
                </span>
                <span className="font-heading font-bold text-[#C9A84C] text-lg" data-id="element-265">
                  45€
                  <span className="font-body text-gray-500 text-xs font-normal ml-1" data-id="element-266">
                    /mes
                  </span>
                </span>
              </div>
              <div className="flex items-center justify-between py-2 border-b border-[#2a2a2a]" data-id="element-267">
                <span className="font-body text-gray-300 text-sm" data-id="element-268">
                  3 clases / semana
                </span>
                <span className="font-heading font-bold text-[#C9A84C] text-lg" data-id="element-269">
                  60€
                  <span className="font-body text-gray-500 text-xs font-normal ml-1" data-id="element-270">
                    /mes
                  </span>
                </span>
              </div>
              <div className="flex items-center justify-between py-2 border-b border-[#2a2a2a]" data-id="element-271">
                <span className="font-body text-gray-300 text-sm" data-id="element-272">
                  4 clases / semana
                </span>
                <span className="font-heading font-bold text-[#C9A84C] text-lg" data-id="element-273">
                  67€
                  <span className="font-body text-gray-500 text-xs font-normal ml-1" data-id="element-274">
                    /mes
                  </span>
                </span>
              </div>
              <div className="flex items-center justify-between py-2 border-b border-[#2a2a2a]" data-id="element-275">
                <span className="font-body text-gray-300 text-sm" data-id="element-276">
                  5 clases / semana
                </span>
                <span className="font-heading font-bold text-[#C9A84C] text-lg" data-id="element-277">
                  74€
                  <span className="font-body text-gray-500 text-xs font-normal ml-1" data-id="element-278">
                    /mes
                  </span>
                </span>
              </div>
            </div>

            <p className="font-body text-gray-500 text-xs italic mb-6 leading-relaxed" data-id="element-279">
              La cuota es mensual y te permite asistir ese número de clases cada
              semana.
            </p>

            <ul className="space-y-3 mb-8 flex-1" data-id="element-280">
              <li className="flex items-center gap-3" data-id="element-281">
                <CheckIcon size={14} className="text-[#C9A84C] flex-shrink-0" data-id="element-282" />
                <span className="font-body text-gray-300 text-sm" data-id="element-283">
                  Grupos por nivel
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-284">
                <CheckIcon size={14} className="text-[#C9A84C] flex-shrink-0" data-id="element-285" />
                <span className="font-body text-gray-300 text-sm" data-id="element-286">
                  Entrenamiento técnico y físico
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-287">
                <CheckIcon size={14} className="text-[#C9A84C] flex-shrink-0" data-id="element-288" />
                <span className="font-body text-gray-300 text-sm" data-id="element-289">
                  Ambiente de equipo
                </span>
              </li>
            </ul>
            <a href="https://wa.me/34646585179?text=Hola%20Antonio,%20quiero%20apuntarme%20a%20las%20clases%20grupales.%20%C2%BFTen%C3%A9is%20plazas%20disponibles?%20Gracias,%20espero%20tu%20respuesta." target="_blank" rel="noopener noreferrer" className="bg-[#C9A84C] hover:bg-[#E8C97A] text-black font-heading font-bold px-6 py-3 text-sm tracking-widest uppercase transition-all duration-200 text-center shadow-lg shadow-[#C9A84C]/25" data-id="element-290">
              Empezar Entrenamiento
            </a>
          </div>
        </div>

        {/* Guarantee */}
        <p className="font-body text-gray-500 text-sm text-center mt-8 italic" data-id="element-291">
          Sin permanencias raras. Lo importante es que entrenes y mejores.
        </p>
      </div>
    </section>;
}